// import { desktop } from 'is_js'

export const isTWA        = () => document.referrer.includes('android-app://com.scales.scaleheaven')
export const isIOS        = () => ['iPhone', 'iPad', 'iPod'].includes(navigator.platform)
// export const isDesktop = () => desktop()
export const isStandAlone = () => window.matchMedia('(display-mode: standalone)').matches
